module.exports = __webpack_public_path__ + "static/img/kejiaohui-top.b160855.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header/kejiaohui-top.png
// module id = HzAN
// module chunks = 53